import React from 'react';
import './CumaMailing.css';

const CumaMailing = () => {
  return (
    <div className="cuma-mailing-container">
      <h2>Cuma Mailing</h2>
      <p>Yakında gelecek...</p>
    </div>
  );
};

export default CumaMailing;
